import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Fisico } from './fisico';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';

@Injectable({
  providedIn: 'root'
})
export class InventariofisicoService {


  constructor(private http: HttpClient) { }

 
  getListar(fecha: string, emisor: string,estado) {  
    
    return this.http.get<Fisico[]>(environment.apiUrl+"/listarInvFisico/?fecha=" + fecha+"&id="+emisor+"&estado="+estado);  
  }  

 

  setActulizar(fisico: Fisico[]){
    console.log(fisico);
    return this.http.put<string>(environment.apiUrl+"/actulizarInvFisico",fisico)
  }

  

  procesarInventario(fisico: Fisico[]){
    console.log(fisico);
    return this.http.put<string>(environment.apiUrl+"/ingresarInventarioFisico",fisico)
  }

  eliminar(id: number){

    return this.http.delete<void>(environment.apiUrl+"/eliminarInvFisico/?id="+id);
  }
  

}
